import { sendToApi } from 'api/client'
import { Template } from 'components/VisualStudioPlayground/Templates/Types'

export interface VisualElement {
  id: number
  name: string
  content: Template
  preview_url: string
  element_type: 'Template' | 'Element'
  description: string
  width: number
  height: number
  source_id?: number
  updated_at: string
  category: string
  type: string
  types: string[]
  style: string[]
  has_replaceable: boolean
  replaceable_has_background: boolean
  status: 'in_review' | 'published'
  basic_layout: boolean
  template_binder_id: number
}

export const VisualElementsClient = {
  createElement: async (
    element: Omit<
      VisualElement,
      | 'id'
      | 'updated_at'
      | 'category'
      | 'type'
      | 'types'
      | 'style'
      | 'preview_url'
      | 'status'
      | 'basic_layout'
      | 'template_binder_id'
    >,
  ) => {
    const res = await sendToApi<VisualElement>(`/visual_elements`, {
      method: 'post',
      body: element,
    })

    return res
  },

  getElement: async (id: number) => {
    const res = await sendToApi<VisualElement>(`/visual_elements/${id}`, {
      method: 'get',
    })

    return res
  },

  getAllElements: async () => {
    const res = await sendToApi<VisualElement[]>(`/visual_elements`, {
      method: 'get',
    })

    return res
  },

  updateElement: async (id: number, updatedElement: Partial<VisualElement>) => {
    const res = await sendToApi<VisualElement>(`/visual_elements/${id}`, {
      method: 'put',
      body: updatedElement,
    })

    return res
  },

  deleteElement: async (id: number) => {
    const res = await sendToApi<void>(`/visual_elements/${id}`, {
      method: 'delete',
    })

    return res
  },
}
